<template>
  <div>
    <router-view></router-view>

    <!-- <customizer></customizer> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: function() {
    return {
      appName: "DOODLE MAKER",
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
  },
  created() {
    if(this.$store.getters.user) {
      this.fetchUser();
    }
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
    themeName() {
      return this.getThemeMode.dark ? "dark-theme" : " ";
    },
    rtl() {
      return this.getThemeMode.rtl ? "rtl" : " ";
    },
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.appName,
      // all titles will be injected into this template
      titleTemplate: "%s",
      // titleTemplate: "%s | VIDEO SLIDER",
      bodyAttrs: {
        class: [this.themeName, "text-left"],
      },
      htmlAttrs: {
        dir: this.rtl,
      },
    };
  },
  mounted() {
    if ("https://" + window.location.hostname == process.env.MIX_RESELLER_URL) {
      this.appName = "MySoftwarePlatform";
    }
  },
};
</script>

<style>
.tooltip-vue {
  background-color: #27282bb2;
}
.tooltip-vue-inner {
  padding: 5px;
  font-size: 0.8rem;
  font-weight: 600;
  color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/App.vue